export const STREAM_STATUS = {
  PENDING: "pending",
  CREATED: "created",
  LIVE: "live",
  COMPLETED: "completed",
  FAILED: "failed",
  STOPPED: "stopped",
};

export const STREAM_ROLES = {
  ORGANISER: "organiser",
  CHALLENGER: "challenger",
  AUDIENCE: "audience",
};

export const EVENT_STATUS = {
  UPCOMING: "Upcoming",
  LIVE: "live",
  COMPLETED: "completed",
  CANCEL: "cancelled",
};

export const STREAM_PLATFORMS = {
  TWITCH: "twitch" as const,
  YOUTUBE: "youtube" as const,
  TWITCH_CAPITALIZED: "Twitch" as const,
  YOUTUBE_CAPITALIZED: "YouTube" as const,
};
